import React from "react";
import { CommandBarButton, IconButton, SelectionMode } from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";

const PlaylistTable = ({
    playlist,
    setSelectedContent,
    loading,
    createOnClick,
    deleteOnClick,
    showAddContent,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu content={item} deleteOnClick={deleteOnClick} setSelectedContent={setSelectedContent} />
            ),
        },
        {
            name: 'ID',
            fieldName: 'contentId',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Title',
            fieldName: 'contentTitle',
            minWidth: 350,
            maxWidth: 500,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Type',
            fieldName: 'contentType',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Category',
            fieldName: 'contentCategory',
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Edit Url',
            fieldName: 'adminPath',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) =>
                item.adminPath ? (
                    <a href={`${window.location.origin}${item.adminPath}`} target="_blank" rel="noopener noreferrer">
                        {`${window.location.origin}${item.adminPath}`}
                    </a>
                ) : null,
        },
    ];

    const items = playlist ?? [];
    
    const selectionHook = (items) => {
        if (items && items[0]) {
            setSelectedContent(items[0]);
        }
    };

    return (
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            shouldUsePagination={false}
            detailsListProps={{ selectionMode: SelectionMode.none}}
            mainColumn={"contentTitle"}
            style={{
                position: "relative",
                height: "80vh",
                width: "80vw",
            }}
            CommandBar={
                !showAddContent ?
                <CommandBarButton
                    iconProps={{ iconName: "Add" }}
                    text="Add Content"
                    onClick={() => createOnClick()}
                />
                : false
            }
            hideFilterField
            hideSelectionDetails
        />
    );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({ deleteOnClick, content, setSelectedContent, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () =>  {
                    setSelectedContent(content);
                    deleteOnClick(content)
                },
            },
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

export default PlaylistTable;
